import React from "react";
import VendorEarningStats from "./VendorEarningStats";
import WithDrawalsRequest from "./WithDrawalRequets";

const WalletsAndPayment = ({ data, walletsHistory, state }) => {
  return (
    <>
      <VendorEarningStats data={data} state={state}/>
      <br />
      <WithDrawalsRequest walletsHistory={walletsHistory} />
    </>
  );
};

export default WalletsAndPayment;
